/**
 * Search-results entity sheet — a thin adapter that maps a search `EntityHit`
 * to the canonical {@link EntityDetailSheet}, so the Research browse grid and
 * per-type lists open the exact same sheet (header, graph actions, body) as
 * every other surface.
 */

import { EntityDetailSheet as SharedEntityDetailSheet } from '@/components/investigations/entity-detail/EntityDetailSheet'
import type { EntityHit } from '@/services/api/case-search'

interface Props {
  caseId: string
  /** When non-null, the sheet is open and the entity is fetched. */
  hit: EntityHit | null
  onClose: () => void
}

export function EntityDetailSheet({ caseId, hit, onClose }: Props) {
  return <SharedEntityDetailSheet caseId={caseId} hit={hit} onClose={onClose} />
}
